export default {
  init () {
    // JavaScript to be fired on all pages
    jQuery('[data-toggle="tooltip"]').tooltip();
    jQuery('#carouselIndicators').carousel();

    jQuery('input, textarea, select').each(function () {
      if (jQuery(this).val()) {
        jQuery(this)
          .next('label')
          .addClass('active');
      }
    });

    jQuery('body').on('click', '[data-class]', function () {
      var data = $(this).attr('data-class');
      // console.log(data);
      jQuery('body').toggleClass(data);
    });

    jQuery('#lang-select-current')
      .on('click', function (e) {
        e.stopPropagation();
        // console.log('toggle')
        jQuery('#lang-select-list')
          .toggle()
      })

    jQuery(document).on('click', function (e) {
      if (!jQuery(e.target).closest('#lang-select-list').length && !jQuery(e.target).is('#lang-select-list')) {
        jQuery('#lang-select-list').hide();
      }
    });

    jQuery('.voice-over-selector-autocomplete').select2();

    jQuery('.voice-over-selector-autocomplete')
      .on('select2:select', function (e) {
        window.location.replace(e.params.data.id)
      })

    // try {

    //   jQuery('.slider-wrapper').slick({
    //     slidesToShow: 2,
    //     swipe: true,
    //     swipeToSlide: false,
    //     adaptiveHeight: true,
    //     infinite: true,
    //     responsive: [{
    //       breakpoint: 991,
    //       settings: {
    //         slidesToShow: 1,
    //       },
    //     }],
    //   });

    // } catch (error) {
    //   console.log('error');
    // }

    // // Pricing plans component

    // let $pricingPlanSelector = jQuery('.voice-over-pricing-plans .pricing_card--premium #pricing-plans');
    // $pricingPlanSelector.select2({
    //   minimumResultsForSearch: Infinity,
    // });

    // let $billingInfo =  jQuery('.voice-over-pricing-plans .pricing_card--premium .billing-info');
    // let cur = $billingInfo.find('.billing-amount').data('cur');
    // $billingInfo.find('.billing-amount').html(cur+$pricingPlanSelector.val());
    // $billingInfo.find('.billing-note').html($pricingPlanSelector.find(':selected').data('note'));
    // $pricingPlanSelector.on('change', function () {
    //   $billingInfo.find('.billing-amount').html(cur+jQuery(this).val());
    //   $billingInfo.find('.billing-note').html(jQuery(this).find(':selected').data('note'));
    // });

    // //    rate-chart component

    // jQuery('.rate-word-selector').select2({ dropdownAutoWidth: true, width: '100%' });
    // jQuery('.rate-word-selector').on('change', function () {
    //   jQuery(this).parents('.rate-words-tile').find('.rate-display .price').html(jQuery(this).find(':selected').data('price'));
    // });

    //    accordions component

    // jQuery('.accordion-title').on('click', function (e) {
    //   e.preventDefault();
    //   jQuery(this).toggleClass('accordion-open').siblings('.accordion-description').slideToggle();
    // });


    // Blog page carousel
    jQuery(function() {
      jQuery('#carouselIndicators').carousel();
    });

    // voice_page_search_popup shortcode js
    jQuery('.voice-page-search-autocomplete').select2({
        dropdownParent: jQuery('.vpsp-inner.vsps-searchbox'),
    });
    jQuery('.voice-page-search-btn').on('click', function(){
        window.location.href = jQuery(this).parents('.vpsp-bottom').find('.voice-page-search-autocomplete').val();
    });
    jQuery('.voice-page-search-autocomplete').on('select2:select', function (e) { 
        window.location.href = e.params.data.id;
    });

  },
  finalize () {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js